import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'

export default (store) => ({
  path: 'product-sales-forecast',
  onEnter: isLoggedIn(store),
  getComponent (nextState, callback) {
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const ProductSalesForecasts = require('./containers/ProductSalesForecastsContainer').default
      const {productSalesForecastsFilterReducer, productForecastsReducer, loadStoreOptionsReducer, loadBillFieldsReducer} = require('./modules/productSalesForecasts')

      injectReducer(store, {key: 'productSalesForecastsFilter', reducer: productSalesForecastsFilterReducer})
      injectReducer(store, {key: 'productForecasts', reducer: productForecastsReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'billFields', reducer: loadBillFieldsReducer})

      /*  Return getComponent   */
      callback(null, ProductSalesForecasts)

      /* Webpack named bundle   */
    }, 'ProductSalesForecastsView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ProductSalesForecasts/index.js